import transformer from '@common-vue/product-carousel/src/utils/Interface';

import { getExperimentIdsFromSeedCookie, isMcom } from './utils';
import { generateTdpQueryParam } from '../analytics/generateTdpQueryParam';

/* istanbul ignore next */
export const setFormattedPercentOff = (price) => {
  const minPercentOff = price?.values?.[0]?.percentOff?.[0];
  const maxPercentOff = price?.values?.length > 1 ? price?.values?.[price.values.length - 1]?.percentOff?.[0] : 0;
  // eslint-disable-next-line no-restricted-syntax
  for (const priceObj of price.values) {
    if (!priceObj.formattedPercentOff && priceObj.percentOff && priceObj.percentOff[0]) {
      priceObj.formattedPercentOff = maxPercentOff > 0 ? `(${minPercentOff}-${maxPercentOff}% off)` : `(${minPercentOff}% off)`;
    }
  }
  return price;
};

export const minDetailProductThumbnail = (product) => {
  const experimentIdsFromSeedCookie = getExperimentIdsFromSeedCookie();

  const {
    detail: {
      brand, name, reviewStatistics, flags,
    },
    id,
    identifier,
    imagery: { images },
    pricing: { price },
  } = product;

  const colorSwatchExperimentIds = ['2483-22', '2483-21'];
  const colorSwatchEnhancement = colorSwatchExperimentIds.some((experimentId) => experimentIdsFromSeedCookie?.includes(experimentId));
  const shouldAddColorSwatch = isMcom() && colorSwatchEnhancement;

  let colorArray = [];
  let selectedColorObj = null;
  let traits;

  if (shouldAddColorSwatch) {
    traits = product?.traits;
    const colors = traits?.colors || {};
    colorArray = colors.colorMap ? Object.values(colors.colorMap) : [];
    selectedColorObj = colorArray.find((color) => color.id === colors.selectedColor) || null;
  }

  const minDetailProduct = {
    detail: { brand, name, flags: { masterProduct: flags?.masterProduct || false } },
    id,
    identifier,
    imagery: { images },
    pricing: { price },
    ...(shouldAddColorSwatch && {
      traits: {
        ...traits,
        colors: {
          ...traits?.colors,
          colorMap: colorArray,
          selectedColor: selectedColorObj,
        },
      },
    }),
  };

  if (isMcom()) {
    minDetailProduct.detail.reviewStatistics = reviewStatistics;
    if (product.pricing?.price?.finalPrice && minDetailProduct?.pricing?.price?.tieredPrice) {
      minDetailProduct.pricing.price.tieredPrice = [minDetailProduct.pricing.price.tieredPrice[0]];
    }
  }
  if (!isMcom() && minDetailProduct.pricing?.price?.finalPrice) {
    delete minDetailProduct.pricing.price.finalPrice;
  }

  const bcomPriceSimplificationExpIds = ['2054-21'];
  const bcomPriceSimplificationExp = bcomPriceSimplificationExpIds.some((experimentId) => experimentIdsFromSeedCookie?.includes(experimentId));
  const shouldSimplifyBcomPrice = !isMcom() && bcomPriceSimplificationExp;

  const hasTieredPrices = !!minDetailProduct.pricing?.price?.tieredPrice?.length;
  const shouldShowPercentOff = isMcom() || shouldSimplifyBcomPrice;
  if (hasTieredPrices && shouldShowPercentOff) {
    // eslint-disable-next-line no-restricted-syntax
    for (const priceObj of minDetailProduct.pricing.price.tieredPrice) {
      const isDiscount = priceObj?.values?.[0]?.type === 'discount' || false;
      if (isDiscount) {
        setFormattedPercentOff(priceObj);
      }
    }
  }

  return minDetailProduct;
};

export const onlyTwoPricesMinDetailTransformer = (product) => {
  const minDetailsProduct = minDetailProductThumbnail(product);
  const price = minDetailsProduct.pricing?.price;
  if (!price?.finalPrice && price?.tieredPrice?.length > 2) {
    price.tieredPrice.sort((p, n) => p.values?.value - n.values?.value);
    price.tieredPrice = [price.tieredPrice[0], price.tieredPrice[price.tieredPrice.length - 1]];
  }
  if (price?.priceType?.text) {
    price.priceType.text = null;
  }

  return minDetailsProduct;
};

// eslint-disable-next-line arrow-body-style
export const productTransformerWithTDPFactory = (
  { requester, zone, choiceId },
  baseTransformer = transformer,
  selectedColor,
  enableColorRecommendations,
  colorSwatchEnhancement,
) => (product, includeMetadata, index) => {
  const transformedProduct = baseTransformer(product, includeMetadata, index, colorSwatchEnhancement);
  if (!product?.identifier) {
    return transformedProduct;
  }

  const tdpParam = generateTdpQueryParam({
    requester,
    zone,
    choiceId,
    position: typeof index === 'number' ? index + 1 : null,
    categoryId: product?.relationships?.taxonomy?.defaultCategoryId,
  });
  const UrlWithQuery = enableColorRecommendations
    ? `${product.identifier.productUrl}&swatchColor=${selectedColor || ''}&${tdpParam}`
    : `${product.identifier.productUrl}&${tdpParam}`;

  return {
    ...transformedProduct,
    identifier: { productUrl: UrlWithQuery, productId: product.identifier.productId },
  };
};
